import { Component, OnInit } from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  isResetError: boolean = false;
  resetMsg: string = "";
  resetProcessInitiated: boolean = true;
  resetService_: any;


  constructor(public resetService: UseraccessserviceService, private router: Router, private toastr: ToastrService, private headerinfo: ComponentheaderService, private schoolService: SchoolmanagementService) {
    this.resetService_ = resetService;
  }



  updateLoadScreen(val: boolean) {
   this.resetService.isLoading = val;
  }

  async OnSubmit(email: string) {
    this.updateLoadScreen(true);
    let id = await this.schoolService.getSchoolIdFromSubdomain().toPromise();
    
    if(id > 0){
      await this.resetService.forgotPassword(email).toPromise().then(
        (response:any)=>{
          this.toastr.success("Reset Password Email Sent");
          console.log(response);
        }
      ).finally(
        ()=>{
          this.updateLoadScreen(false);
        }
      ); 
    }
    else{
      this.toastr.error("No school Found. Kindly validate that school URL is correct.");
      this.updateLoadScreen(true);
      this.resetService.isLoading = false;
      return;
    }  

    this.router.navigate(['/access/login']);
  }

  ngOnInit(): void {
    this.headerinfo.setPageTitle('Forgot Password');
  }

}
